import React from 'react';
import { useForm } from 'react-hook-form';
import { FormStepContentProps } from 'types';
import { FormDataType, useFormState } from 'contexts/FormProvider';
import { useScrollTop } from 'hooks/useScrollTop';
import { useCheckWindowCMS } from 'hooks/useCheckWindowCMS';
import { FormCard } from '@qbe/ads-blocks-forms';
import { select } from 'resources/customerProperties';
import PersonalDetails from './sections/PersonalDetails';
import ContactDetails from './sections/ContactDetails';
import validationSchema, { personalDetailsSchema, contactDetailSchema } from './schema';
import { TrackEvent, formatNext, setFormCompleteEvent } from 'hooks/useAnalytics';
import { Form } from 'components';
import { yupResolver } from '@hookform/resolvers/yup';

const YourDetailsForm = ({ onComplete }: FormStepContentProps) => {
  useScrollTop();
  useCheckWindowCMS();

  const { formData, updateForm } = useFormState();

  const form = useForm<FormDataType>({
    mode: 'onBlur',
    defaultValues: formData,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: yupResolver(validationSchema) as any,
  });

  const { handleSubmit, watch, getValues } = form;

  const values = watch();

  const isContactDetailsValid = contactDetailSchema.isValidSync(values);
  const [isContactDetailsDisplayed, setIsContactDetailsDisplayed] = React.useState(false);
  const [showBtnContactDetails, setShowBtnContactDetails] = React.useState(true);

  const isPersonalDetailsValid = personalDetailsSchema.isValidSync(values);
  const [showPersonalDetailsButton, setShowPersonalDetailsButton] = React.useState(true);

  const onSubmit = (newData: Partial<FormDataType>) => {
    setFormCompleteEvent();
    onComplete(newData);

    if (newData.addressType === 'yes') {
      updateForm({
        postalAddress: null,
        isManualPosAddress: false,
        posStreetAddress: '',
        posSuburb: '',
        posCountry: '',
        posState: '',
        posPostcode: '',
      });
    }

    if (newData.nominatedRepType === 'no') {
      updateForm({
        repContactMethod: '',
        repMPhoneNumber: '',
        repHPhoneNumber: '',
        repOPhoneNumber: '',
        repFirstName: '',
        repLastName: '',
        repEmailAddress: '',
        repPostalAddress: '',
      });
    }

    if (newData.nominatedRepType === 'yes' && newData.repContactMethod === 'post') {
      updateForm({
        repMPhoneNumber: '',
        repHPhoneNumber: '',
        repOPhoneNumber: '',
        repEmailAddress: '',
      });
    }

    if (newData.nominatedRepType === 'yes' && newData.repContactMethod === 'email') {
      updateForm({
        repMPhoneNumber: '',
        repHPhoneNumber: '',
        repOPhoneNumber: '',
        repPostalAddress: null,
        isManualRepPosAddress: false,
        repPosStreetAddress: '',
        repPosSuburb: '',
        repPosCountry: '',
        repPosState: '',
        repPosPostcode: '',
      });
    }

    if (newData.nominatedRepType === 'yes' && newData.repContactMethod === 'phone') {
      updateForm({
        repEmailAddress: '',
        repPostalAddress: null,
        isManualRepPosAddress: false,
        repPosStreetAddress: '',
        repPosSuburb: '',
        repPosCountry: '',
        repPosState: '',
        repPosPostcode: '',
      });
    }
  };
  const handleSubmitPersonalDetails = () => {
    setShowPersonalDetailsButton(false);
    setShowBtnContactDetails(true);
    setIsContactDetailsDisplayed(true);
    TrackEvent(formatNext('nextPersonalDetails'), getValues());
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)} data-test="consent-form">
      <FormCard title={select('consent.insured.form.heading')} description="" variant="pageTitle" />

      <PersonalDetails
        form={form}
        enableNextButton={isPersonalDetailsValid}
        showNextButton={showPersonalDetailsButton}
        onSubmit={handleSubmitPersonalDetails}
      />

      <ContactDetails
        form={form}
        show={isContactDetailsDisplayed}
        showNextButton={showBtnContactDetails}
        isContactDetailsValid={isContactDetailsValid}
      />
    </Form>
  );
};

export default YourDetailsForm;
